import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { appVariant } from '../config/appVariant';

const Login = () => {
	const [password, setPassword] = useState('');
	const [error, setError] = useState('');
	const { login } = useAuth();
	const navigate = useNavigate();

	const handleSubmit = (e) => {
		e.preventDefault();
		if (login(password)) {
			setError('');
			navigate(appVariant.defaultRoute, { replace: true });
		} else {
			setError('Access Denied');
		}
	};

	return (
		<div className="login-page">
			<form onSubmit={handleSubmit} className="login-form">
				<input
					type="text"
					autoComplete="username"
					value="lavella"
					readOnly
					style={{ display: 'none' }}
				/>
				<input
					type="password"
					autoComplete="current-password"
					placeholder="access"
					value={password}
					onChange={(e) => setPassword(e.target.value)}
					autoFocus
				/>
				<button type="submit">Login</button>
				{error && <p className="login-error">{error}</p>}
			</form>
		</div>
	);
};

export default Login;
